import type { LucideIcon } from "lucide-react";
import {
  Home,
  LibraryBig,
  School,
  Gamepad2,
  Sparkles,
  Gift,
  Megaphone,
  ImagePlus,
  ShieldCheck,
  Crown,
  Sticker,
  BookOpen,
  LayoutGrid,
  FolderHeart,
  LayoutTemplate,
  GraduationCap,
  UserCog,
  Settings2,
} from "lucide-react";

export interface NavItem {
  label: string;
  href: string;
  icon: LucideIcon;
  /** Mục con (submenu). Khi có, mục cha bấm để mở/gập; ở chế độ thu gọn link tới con đầu. */
  children?: NavItem[];
}

/** Navigation chính — tối đa 7 mục cấp cao (Volume 02 §14, Volume 04 §1.1). */
export const primaryNav: NavItem[] = [
  { label: "Trang chủ", href: "/bang-dieu-khien", icon: Home },
  { label: "Kho tài liệu", href: "/tai-lieu/doc-quyen", icon: LibraryBig },
  { label: "Lớp học", href: "/lop-hoc", icon: School },
  { label: "Trò chơi", href: "/tro-choi", icon: Gamepad2 },
  { label: "Trợ lý AI", href: "/tro-ly-ai", icon: Sparkles },
  { label: "Tạo ảnh AI", href: "/tao-anh-ai", icon: ImagePlus },
  // Ẩn tạm (bật lại khi cần):
  // { label: "Cộng đồng", href: "/cong-dong", icon: Users },
  // { label: "Mời bạn", href: "/gioi-thieu", icon: Gift },
  {
    label: "Tiện ích",
    href: "/kho-icon", // dùng khi thu gọn (link tới mục con đầu tiên)
    icon: LayoutGrid,
    children: [
      { label: "Kho biểu tượng", href: "/kho-icon", icon: Sticker },
      { label: "Đổi khối lớp", href: "/tien-ich/doi-khoi", icon: GraduationCap },
    ],
  },
  {
    label: "Cấu hình",
    href: "/cau-hinh/ky-nang", // dùng khi thu gọn (link tới mục con đầu tiên)
    icon: Settings2,
    children: [
      { label: "Bộ kỹ năng", href: "/cau-hinh/ky-nang", icon: Sparkles },
    ],
  },
];

/** Điều hướng chỉ dành cho quản trị/kiểm duyệt viên. */
export const adminNav: NavItem[] = [
  { label: "Tài khoản giáo viên", href: "/quan-tri/tai-khoan-giao-vien", icon: UserCog },
  { label: "Duyệt tài liệu", href: "/quan-tri/duyet-tai-lieu", icon: ShieldCheck },
  { label: "Quản lý trường", href: "/quan-tri/truong", icon: School },
  { label: "Đổi khối lớp", href: "/quan-tri/doi-khoi", icon: GraduationCap },
  { label: "Đăng tài liệu nền tảng", href: "/quan-tri/tai-lieu/dang", icon: Crown },
  { label: "Kho tài nguyên", href: "/quan-tri/tai-nguyen", icon: FolderHeart },
  { label: "Trò chơi giới thiệu", href: "/quan-tri/tro-choi", icon: Gamepad2 },
  { label: "Overlay quảng cáo", href: "/quan-tri/overlay-quang-cao", icon: Megaphone },
  { label: "Yêu cầu tạo ảnh/video", href: "/quan-tri/yeu-cau-ai", icon: ImagePlus },
  { label: "Mẫu nhãn vở", href: "/quan-tri/mau-nhan", icon: LayoutTemplate },
  { label: "Chiến dịch giới thiệu", href: "/quan-tri/chien-dich-gioi-thieu", icon: Gift },
  { label: "Môn học", href: "/mon-hoc", icon: BookOpen },
];
